// payments-api.js
import { ProtectedHttpClient } from "../shared/clients/http-client";

const PaymentsApi = {
  private: {
    createCheckoutSession: (organizationId) =>
      ProtectedHttpClient.post(`/payments/stripe/checkout-session/${organizationId}`),
    createBillingPortalSession: (organizationId) =>
      ProtectedHttpClient.post(`/payments/stripe/billing-portal-session/${organizationId}`),
    getSubscription: (organizationId) =>
      ProtectedHttpClient.get(`/payments/stripe/subscription/${organizationId}`),
  },
};

export default PaymentsApi;
